import styled from "styled-components";
import windowSize from "../../../constants/WindowSize";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
  padding: 20px 0 0 0;
  background-size: cover;
  background-color: #ffffff;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin: ${({ width }) => (width >= windowSize.SM ? "40px auto" : 0)};
  max-width: 450px;
`;

export const ContainerWithIcon = styled.div`
  width: 100%;
  padding: ${({ width }) => (width >= windowSize.SM ? `60px 60px` : `0 20px`)};
  box-shadow: ${({ width }) =>
    width >= windowSize.SM
      ? `0px 1px 1px rgba(0, 0, 0, 0.14), 
        0px 2px 1px rgba(0, 0, 0, 0.12),
        0px 1px 3px rgba(0, 0, 0, 0.2);`
      : "none"};
  border-radius: 4px;
`;

export const ContainerInputs = styled.div`
  > h1 {
    color: #4D4C4D;
    margin-bottom: 20px;
    font-family: "Cera Pro Regular", sans-serif;
    font-weight: 600;
    text-align: center;
  }

  > h3 {
    color: #4D4C4D;
    text-align: center;
    margin-bottom: 20px;
    font-family: "Cera Pro Regular", sans-serif;
    font-weight: 600;
  }

  p {
    text-align: center;
    color: #4D4C4D;
    font-size: 14px;
    font-family: "Cera Pro Regular", sans-serif;
    font-weight: 500;
  }

  small {
    color: #4D4C4D;
    font-family: "Cera Pro Regular", sans-serif;
  }

  button {
    margin-top: 50px;
  }

  a {
    display: flex;
    flex: 1;
    padding: 15px 0;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border: none;
    color: #4D4C4D;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 600;
    font-family: "Cera Pro Regular", sans-serif;

    :hover {
      transition: opacity 0.4s;
      opacity: 0.8;
      text-decoration: underline !important;
    }
  }
`;

export const ContainerReCaptcha = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;
